/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { MedicalSystemSubCategory } from './MedicalSystemSubCategory';
import {
    MedicalSystemSubCategoryFromJSON,
    MedicalSystemSubCategoryFromJSONTyped,
    MedicalSystemSubCategoryToJSON,
} from './MedicalSystemSubCategory';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { RtSystemCategory } from './RtSystemCategory';
import {
    RtSystemCategoryFromJSON,
    RtSystemCategoryFromJSONTyped,
    RtSystemCategoryToJSON,
} from './RtSystemCategory';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { TaskItemAreaDto } from './TaskItemAreaDto';
import {
    TaskItemAreaDtoFromJSON,
    TaskItemAreaDtoFromJSONTyped,
    TaskItemAreaDtoToJSON,
} from './TaskItemAreaDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface TaskItemDto
 */
export interface TaskItemDto {
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaskItemDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TaskItemDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof TaskItemDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TaskItemDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TaskItemDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof TaskItemDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof TaskItemDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof TaskItemDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof TaskItemDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof TaskItemDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<TaskItemAreaDto>}
     * @memberof TaskItemDto
     */
    taskItemAreas?: Array<TaskItemAreaDto> | null;
    /**
     * 
     * @type {RtSystemCategory}
     * @memberof TaskItemDto
     */
    category?: RtSystemCategory;
    /**
     * 
     * @type {MedicalSystemSubCategory}
     * @memberof TaskItemDto
     */
    subCategory?: MedicalSystemSubCategory;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof TaskItemDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof TaskItemDto
     */
    $type?: TaskItemDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemDtoTypeEnum = typeof TaskItemDtoTypeEnum[keyof typeof TaskItemDtoTypeEnum];


/**
 * Check if a given object implements the TaskItemDto interface.
 */
export function instanceOfTaskItemDto(value?: unknown): value is TaskItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemDtoTypeEnum)[0];
}

export function TaskItemDtoFromJSON(json: any): TaskItemDto {
    return TaskItemDtoFromJSONTyped(json, false);
}

export function TaskItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'taskItemAreas': !exists(json, 'taskItemAreas') ? undefined : (json['taskItemAreas'] === null ? null : (json['taskItemAreas'] as Array<any>).map(TaskItemAreaDtoFromJSON)),
        'category': !exists(json, 'category') ? undefined : RtSystemCategoryFromJSON(json['category']),
        'subCategory': !exists(json, 'subCategory') ? undefined : MedicalSystemSubCategoryFromJSON(json['subCategory']),
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TaskItemDtoToJSON(value?: TaskItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value.state),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'taskItemAreas': value.taskItemAreas === undefined ? undefined : (value.taskItemAreas === null ? null : (value.taskItemAreas as Array<any>).map(TaskItemAreaDtoToJSON)),
        'category': RtSystemCategoryToJSON(value.category),
        'subCategory': MedicalSystemSubCategoryToJSON(value.subCategory),
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        '$type': value.$type,
    });
}

